<div class="profile-page-container" *ngIf="profileForm">
    <form [formGroup]="profileForm" class="profile-form">
        <div class="form-boxes-wrapper">
            <!-- Left Box: Personal Data -->
            <div class="border-container left-box">
                <!-- Name fields (side-by-side layout) -->
                <div class="form-group">
                    <label for="firstName">{{ 'user.userArea.profile.name.label' | translate }}</label>
                    <div class="name-field-container">
                        <div *ngFor="let field of nameFields" class="input-wrapper position-relative">
                            <input
                                type="text"
                                [id]="field.id"
                                class="profile-form-control"
                                [class]="'profile-form-control ' + field.cssClass"
                                [formControlName]="field.id"
                                [readonly]="updating"
                                (focusout)="focusFieldOnError($event, field.id)"
                            />
                            <div class="error-div" *ngIf="!profileForm?.get(field.id)?.pristine && profileForm?.get(field.id)?.invalid">
                                <app-display-errors
                                    [control]="profileForm.get(field.id)"
                                    [translationKey]="field.translationKey"
                                ></app-display-errors>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Address fields -->
                <div *ngFor="let field of addressFields" class="form-group">
                    <label [for]="field.id">{{ field.labelKey | translate }}</label>
                    <div class="input-wrapper position-relative">
                        <input
                            type="text"
                            [id]="field.id"
                            class="profile-form-control"
                            [formControlName]="field.id"
                            [readonly]="updating"
                            (focusout)="focusFieldOnError($event, field.id)"
                        />
                        <div class="error-div" *ngIf="!profileForm?.get(field.id)?.pristine && profileForm?.get(field.id)?.invalid">
                            <app-display-errors
                                [control]="profileForm.get(field.id)"
                                [translationKey]="field.errorKey"
                            ></app-display-errors>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right Column: Account Settings + Save Button -->
            <div class="right-column">
                <div class="border-container right-box">
                    <div class="form-group">
                        <label for="username">{{
                                'user.userArea.profile.username' | translate
                            }}</label>
                        <input
                            type="text"
                            id="username"
                            class="profile-form-control readonly"
                            [value]="username"
                            readonly
                        />
                    </div>

                    <div class="form-group">
                        <label for="email">{{
                                'user.userArea.profile.email' | translate
                            }}</label>
                        <input
                            type="text"
                            id="email"
                            class="profile-form-control readonly"
                            [value]="userEmail"
                            readonly
                        />
                    </div>

                    <div class="form-group">
                        <label for="language">{{
                                'user.userArea.profile.language' | translate
                            }}</label>
                        <select
                            id="language"
                            class="profile-form-control"
                            formControlName="language"
                            [attr.disabled]="updating ? true : null"
                        >
                            <!-- Placeholder only (not a dropdown choice) -->
                            <option [ngValue]="null" disabled hidden>
                                {{
                                    'user.userArea.profile.languageOptions.automatic'
                                        | translate
                                }}
                            </option>
                            <option [value]="LanguageCode.DE">
                                {{
                                    'user.userArea.profile.languageOptions.german'
                                        | translate
                                }}
                            </option>
                            <option [value]="LanguageCode.EN">
                                {{
                                    'user.userArea.profile.languageOptions.english'
                                        | translate
                                }}
                            </option>
                        </select>
                    </div>

                    <div class="form-group" *ngIf="isUserExperimental">
                        <label for="enableNonEuRegions">{{
                                'user.userArea.profile.enableNonEuRegions.label' | translate
                            }}</label>
                        <div class="d-flex align-items-center gap-2">
                            <div class="form-check mb-0">
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    id="enableNonEuRegions"
                                    formControlName="enableNonEuRegions"
                                    [attr.disabled]="updating ? true : null"
                                />
                            </div>
                            <i
                                class="bi bi-info-circle info-icon"
                                [title]="'user.userArea.profile.enableNonEuRegions.hint' | translate"
                            ></i>
                        </div>
                    </div>

                    <div class="form-group button-row">
                        <div class="button-wrapper-tryb-button">
                            <button
                                id="user-profile-change-password-button"
                                type="button"
                                class="button-tryb-button basic-tryb-button"
                                (click)="onChangePassword()"
                            >
                                {{
                                    'user.userArea.profile.changePassword'
                                        | translate
                                }}
                            </button>
                        </div>
                    </div>

                    <div
                        *ngIf="isUserExperimental"
                        class="form-group button-row">
                        <div class="button-wrapper-tryb-button">
                            <button
                                id="user-profile-delete-account-button"
                                type="button"
                                class="button-tryb-button delete-tryb-button"
                                (click)="onDeleteAccount()"
                            >
                                {{
                                    'user.userArea.profile.deleteAccount'
                                        | translate
                                }}
                            </button>
                        </div>
                    </div>
                </div>

                <div class="save-button-container">
                    <div class="button-wrapper-tryb-button">
                        <button
                            id="user-profile-save-changes-button"
                            type="button"
                            class="button-tryb-button standard-tryb-button"
                            (click)="saveChanges()"
                            [disabled]="!hasUnsavedChanges() || profileForm.invalid || updating"
                        >
                            {{ 'user.userArea.profile.saveChanges' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
